import React from "react";
import CloseIconButton from "../../../../../components/CloseIconButton";
import { Dialog } from "@headlessui/react";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { mainSelectedTab } from "../../../atoms";
import { OfficeTabs } from "../../../../OfficeTab/OfficeTabs";
import { accountAtom } from "modules/Login/atoms/AccountAtom";
interface FranchiseOfficeDetailsModalProps {
  data: any;
  showOfficeDetails: boolean;
  closeOfficeDetails: () => void;
}

const FranchiseOfficeDetailsModal: React.FC<
  FranchiseOfficeDetailsModalProps
> = ({ data, showOfficeDetails, closeOfficeDetails }) => {
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const userPermissions = useRecoilValue(permissionsSelector);
  const history = useHistory();
  const user = useRecoilValue(accountAtom);

  const handleOfficeClick = (data, x) => {
    localStorage.setItem("empId", data?.employeeId);

    const url = "/officesettings/officesetting";

    history.push({
      pathname: url,
      state: {
        action: "employeeFranchiseOfficeModal",
        officeCodes: x.officeCode,
        employeeId: data.employeeId,
        officeCode: data?.officecode,
      },
    });

    globalThis.location.reload();

    const userTabs = [...OfficeTabs]
      .filter((tabs) => [...userPermissions].includes(tabs.permission))
      .map((tabs) => ({ to: tabs.to }));

    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  return (
    <Dialog
      open={showOfficeDetails}
      onClose={() => {}}
      className="relative z-40 overflow-visible"
    >
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      {/* Full-screen scrollable container */}
      <div className="fixed inset-0">
        {/* Container to center the panel */}
        <div className="flex min-h-screen items-center justify-center p-4">
          {/* The actual dialog panel  */}
          <Dialog.Panel className="max-w-xxl h-1/2 transform overflow-visible rounded bg-white border-primary border-quinary border-l-4 p-3 shadow-xl transition-all opacity-100 scale-100">
            <CloseIconButton onClick={() => closeOfficeDetails()} />
            <div className="blueAndBold flex justify-between px-2 pb-1 border-secondary border-b-2">
              Office Details
            </div>
            <div
              className={
                data?.empOfficeDetails?.length <= 3
                  ? "h-auto overflow-y-auto overflow-hidden"
                  : "h-96 overflow-y-auto overflow-hidden"
              }
            >
              {data?.empOfficeDetails?.length > 0 ? (
                data?.empOfficeDetails?.map((x) => {
                  return (
                    <div key={x.officeId} className="p-2">
                      <div className="grid grid-cols-3 p-1">
                        <label className="col-span-1 expandedLabel fontExpand">
                          Office Code:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {x.officeCode}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-1">
                        <label className="col-span-1 expandedLabel fontExpand">
                          Phone Number:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          {x.phone}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 p-1">
                        <label className="col-span-1 expandedLabel fontExpand">
                          Office Name:
                        </label>
                        {user.isFranchise ? (
                          <button
                            type="button"
                            className="col-span-2 expandedData fontExpand blueAndBold underline cursor-pointer bg-transparent border-0 text-left"
                            onClick={() => handleOfficeClick(data, x)}
                          >
                            {x.officeName}
                          </button>
                        ) : (
                          <div className="col-span-2 expandedData fontExpand">
                            {x.officeName}
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-3 p-1">
                        <label className="col-span-1 expandedLabel fontExpand">
                          Office Address:
                        </label>
                        <div className="col-span-2 expandedData fontExpand">
                          <div>
                            {x.suiteNumber} {x.address} {x.city}, {x.state}{" "}
                            {x.zipCode}
                          </div>
                          <div>{x.country}</div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="p-4 text-center text-gray-500">
                  No office details available.
                </div>
              )}
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};
export default FranchiseOfficeDetailsModal;
